import { render, staticRenderFns } from "./IdentityVerificationFooter.vue?vue&type=template&id=09b3038e&scoped=true"
import script from "./IdentityVerificationFooter.vue?vue&type=script&lang=js"
export * from "./IdentityVerificationFooter.vue?vue&type=script&lang=js"
import style0 from "./IdentityVerificationFooter.vue?vue&type=style&index=0&id=09b3038e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b3038e",
  null
  
)

export default component.exports